module.exports = __webpack_public_path__ + "img/outlook_32x1.117f82a8.svg";